import React from 'react';
import { Link } from 'react-router-dom';

// Public share-friendly landing page at /sg/share.
// Designed to be the URL that gets pasted into WhatsApp / email — when
// recipients open it on their phone they can TAP the button to view
// the invitation directly (no QR scanning needed). The QR is still
// shown below the button for cross-device sharing scenarios
// (printed on cards, displayed on a screen for others to scan).
export default function SingaporeInviteShare() {
  // Try to detect Arvind logo from the rendered PDF (page-1 has it
  // embedded). For simplicity here we use the same logo file path
  // that backs the QR card builder.
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0A1A2F',
        margin: 0,
        padding: 0,
        WebkitFontSmoothing: 'antialiased',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        color: '#F5EBD7',
      }}
    >
      <div
        style={{
          maxWidth: 560,
          margin: '0 auto',
          padding: '40px 24px 60px',
          textAlign: 'center',
        }}
      >
        {/* Decorative double-gold border, mirroring the QR card */}
        <div
          style={{
            border: '2px solid #D4A85A',
            outline: '1px solid #C9A961',
            outlineOffset: 4,
            borderRadius: 8,
            padding: '40px 24px 36px',
          }}
        >
          {/* Arvind logo (extracted from the source PDF artwork) */}
          <img
            src="/sg/arvind-logo.png"
            alt="Arvind"
            style={{
              width: 120,
              height: 120,
              display: 'block',
              margin: '0 auto 18px',
              borderRadius: 6,
            }}
          />

          {/* Eyebrow */}
          <div
            style={{
              fontSize: 11,
              letterSpacing: '0.20em',
              color: '#D4A85A',
              fontWeight: 700,
              marginBottom: 20,
            }}
          >
            HOSTED WITH PRIDE BY ARVIND
          </div>

          {/* Headline */}
          <div
            style={{
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontWeight: 700,
              color: '#fff',
              fontSize: 36,
              lineHeight: 1.15,
              marginBottom: 4,
            }}
          >
            Your Exclusive Invite
          </div>
          <div
            style={{
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontWeight: 700,
              fontSize: 36,
              lineHeight: 1.15,
              marginBottom: 14,
            }}
          >
            <span style={{ color: '#fff' }}>is </span>
            <span style={{ color: '#D4A85A', fontStyle: 'italic' }}>here</span>
          </div>

          {/* Subtitle */}
          <div
            style={{
              fontFamily: 'Georgia, "Times New Roman", serif',
              fontStyle: 'italic',
              color: '#F5EBD7',
              fontSize: 17,
              marginBottom: 8,
            }}
          >
            Singapore 2026 · 9 — 14 July
          </div>
          <div
            style={{
              width: 80,
              height: 2,
              background: '#D4A85A',
              margin: '12px auto 32px',
            }}
          />

          {/* Big primary CTA — tap to open invitation */}
          <Link
            to="/sg"
            style={{
              display: 'inline-block',
              padding: '18px 40px',
              background: '#D4A85A',
              color: '#0A1A2F',
              fontWeight: 800,
              fontSize: 16,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              textDecoration: 'none',
              borderRadius: 6,
              boxShadow: '0 6px 18px rgba(212, 168, 90, 0.35)',
            }}
          >
            Tap to view your invitation →
          </Link>
          <div
            style={{
              fontSize: 12,
              color: '#94A3B8',
              marginTop: 14,
              letterSpacing: '0.04em',
            }}
          >
            (Opens the full Singapore 2026 invite on this device)
          </div>

          {/* QR code block — for cross-device scanning */}
          <div
            style={{
              marginTop: 36,
              paddingTop: 28,
              borderTop: '1px solid rgba(212, 168, 90, 0.2)',
            }}
          >
            <div
              style={{
                fontSize: 11,
                letterSpacing: '0.2em',
                color: '#D4A85A',
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              OR SCAN WITH ANOTHER DEVICE
            </div>
            <div
              style={{
                background: '#fff',
                borderRadius: 12,
                padding: 16,
                display: 'inline-block',
              }}
            >
              <img
                src="/sg/qr-only.png"
                alt="QR code linking to maarkett.com/sg"
                style={{ width: 220, height: 220, display: 'block' }}
              />
            </div>
            <div
              style={{
                fontSize: 13,
                color: '#F5EBD7',
                marginTop: 14,
                fontFamily: 'Georgia, serif',
              }}
            >
              maarkett.com/sg
            </div>
          </div>

          {/* Featuring */}
          <div
            style={{
              marginTop: 32,
              paddingTop: 22,
              borderTop: '1px solid rgba(212, 168, 90, 0.2)',
            }}
          >
            <div
              style={{
                fontSize: 11,
                letterSpacing: '0.2em',
                color: '#D4A85A',
                fontWeight: 700,
                marginBottom: 8,
              }}
            >
              FEATURING
            </div>
            <div
              style={{
                fontFamily: 'Georgia, "Times New Roman", serif',
                fontSize: 22,
                fontWeight: 700,
                color: '#fff',
                letterSpacing: '0.03em',
              }}
            >
              Tresca · Primante
            </div>
          </div>
        </div>

        {/* Discreet 'Save as PDF' for the host — downloads a tappable
            PDF copy (with embedded hyperlinks on the QR and button) so
            it can be sent as a file attachment via WhatsApp / email. */}
        <div style={{ textAlign: 'center', marginTop: 18 }}>
          <a
            href="/sg/share.pdf"
            download="Singapore-2026-QR-Invite.pdf"
            style={{
              fontSize: 11,
              color: '#94A3B8',
              textDecoration: 'none',
              borderBottom: '1px dotted #94A3B8',
              paddingBottom: 1,
              letterSpacing: '0.04em',
            }}
          >
            Save this card as a tappable PDF
          </a>
        </div>

        {/* Deomart PRO branding intentionally NOT shown on this page —
            this is an Arvind-hosted event, so the share/QR artefact
            stays purely Arvind-branded. The Deomart PRO footer lives
            on the invitation page itself (/sg) only. */}
      </div>
    </div>
  );
}
